<div class="lg:tw-w-[700px] tw-w-[70vw]">
  <!--title -->
  <app-modal-title
    [title]="formPageConfig.title | translate"
    [isShowClose]="true"
    (isCloseModal)="onClose()"
  ></app-modal-title>

  <mat-dialog-content
    class="dialog-content"
    style="padding-bottom: 0px !important"
  >
    <!-- form -->
    <form [formGroup]="form">
      <fieldset class="tw-h-full">
        <legend>
          {{ "common.ip" | translate }}
        </legend>

        <!-- allIps -->
        <organization-confirmed-safeIp-selection-list
          [isRequired]="true"
          [organizationId]="organizationId"
          [label]="fields + 'ip'"
          responsiveClass="xl:tw-w-1/2"
          searchBoxGridClass="sm:tw-w-1/2 tw-w-full sm:tw-pl-[25px] sm:ltr:tw-pr-[25px]"
          optionCustomClass="font-vazir-ui"
          searchLabel="common.search"
          [form]="form"
          controlName="ip"
          [values]="allIps"
          (values)="getIps($event)"
        >
        </organization-confirmed-safeIp-selection-list>

        <div class="row tw-mt-10">
          <!-- isCanSendSmart -->
          <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/2">
            <mat-slide-toggle
              formControlName="isCanSendSmart"
              [(ngModel)]="model.isCanSendSmart"
            >
              {{ fields + "isCanSendSmart" | translate }}</mat-slide-toggle
            >
          </div>

          <!-- isIgnoreCheckIp -->
          <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/2">
            <mat-slide-toggle
              formControlName="isIgnoreCheckIp"
              [(ngModel)]="model.isIgnoreCheckIp"
            >
              {{ fields + "isIgnoreCheckIp" | translate }}</mat-slide-toggle
            >
          </div>

          <!-- isCanSend -->
          <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/2">
            <mat-slide-toggle
              formControlName="isCanSend"
              [(ngModel)]="model.isCanSend"
            >
              {{ fields + "isCanSend" | translate }}
            </mat-slide-toggle>
          </div>
        </div>

        <!-- description -->
        <div class="tw-pl-[25px] ltr:tw-pr-[25px] tw-mt-4">
          <form-textarea
            class="tw-w-full font-vazir-ui"
            label="common.description"
            [(value)]="model.description"
            [control]="form?.get('description')"
            [rows]="1"
            maxlength="100"
          >
          </form-textarea>
        </div>
      </fieldset>

      <!-- form btns-->
      <div
        class="tw-bg-white dark:!tw-bg-[#262638] tw-bottom-0 tw-sticky tw-w-full tw-pb-6"
      >
        <app-form-btns
          [loading]="loading"
          [form]="form"
          [isEdit]="formPageConfig.isEditMode"
          (onClose)="onClose()"
          (onSubmit)="onSubmit()"
        >
        </app-form-btns>
      </div>
    </form>
  </mat-dialog-content>
</div>
